const COMPONENT_NAME = "WarehouseSelectorUI";
const COMPOSABLE_DATA_MY_WAREHOUSE = "myWarehouse";
const COMPOSABLE_DATA_SET_MY_WAREHOUSE = "setMyWarehouse";
const COMPOSABLE_DATA_CHANGE_MY_WAREHOUSE = "changeMyWarehouse";
const COMPOSABLE_DATA_ARIA_LABEL = "warehouseAriaLabelSuffix";
const COMPOSABLE_DATA_ICON_TITLE = "warehouseIconTitle";
const ICON_SIZE = "20px";
export {
  COMPONENT_NAME,
  COMPOSABLE_DATA_ARIA_LABEL,
  COMPOSABLE_DATA_CHANGE_MY_WAREHOUSE,
  COMPOSABLE_DATA_ICON_TITLE,
  COMPOSABLE_DATA_MY_WAREHOUSE,
  COMPOSABLE_DATA_SET_MY_WAREHOUSE,
  ICON_SIZE
};
